import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux"
import md5 from 'js-md5'

import { getAuth } from '../../app/authSlice.js'
import { useEffect, useState } from "react";

let contador = false
const LoginProtectedRoute = ({ user, children }) => {
    const dirWebApp = process.env.REACT_APP_DIR_PRO
    const dispatch = useDispatch()
    const validarUserLogin = useSelector(state => state.auth.IdEmp)

    const urlAdmin = process.env.REACT_APP_URL_API_SEG // Para pruebas
    // const urlAdmin = process.env.REACT_APP_URL_API_PRO_SEG // Para producción 

    // useEffect(() => {
    // if (intFech) {
    if ((validarUserLogin === null || validarUserLogin === undefined || validarUserLogin === '' || validarUserLogin === false) && !contador) {
        contador = true
        dispatch(getAuth({
            config: {
                method: "POST", //Propiedad method, "POST", "GET", etc
                url: urlAdmin + "/seguridad/login", //URL de la API
                headers: {
                    'Authorization': process.env.REACT_APP_TOKEN_API,
                    'Content-ID': process.env.REACT_APP_AUDIENCIA_API,
                    'Content-Type': 'application/json'
                }, //Propiedad headers, por si la API solicita token, audiencia, etc
                payload: JSON.stringify({ LoginId: 'publico', password: 'c@mpu$V4' }), //Propiedad payload --> datos a enviar en la solicitud http
            },
            rememberUser: false,
        }))
    }
    // }, [])
    // const modalAdmisiones = JSON.parse(localStorage.getItem('showAdmisiones'))

    const validarUser = useSelector(state => state.auth.IdEmp)
    // if (modalAdmisiones) {
    //     localStorage.removeItem('showAdmisiones')
    //     return <Navigate to={`${dirWebApp}admisiones`} replace />
    // } else {
    if (validarUser === 'PPUBLIC001') {
        localStorage.removeItem('showAdmisiones')
        return children
    } else {
        // if (contador) {
        //     return <Navigate to={`${dirWebApp}admisiones`} replace />
        // } else {
        if (user) {
            return <Navigate to={dirWebApp} replace />
        } else {
            return children
        }
    }
    // }
    // }
}

export default LoginProtectedRoute